import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import React from 'react';
import { ComboBoxContext } from "./ComboBoxContext";
import { theme } from "../../theme";
import { ComboBoxItemText } from "./ComboBoxItemText";
import styled from 'styled-components';
/**
 * `ComboBoxOption`
 * Individual combobox option
 */

export var ComboBoxItem = function ComboBoxItem(_ref) {
  var children = _ref.children,
      index = _ref.index,
      item = _ref.item,
      disabled = _ref.disabled,
      style = _ref.style,
      other = _objectWithoutProperties(_ref, ["children", "index", "item", "disabled", "style"]);

  var context = React.useContext(ComboBoxContext);

  if (!context) {
    throw new Error('ComboBoxItem must be wrapped in a ComboBox component');
  }

  var getItemProps = context.getItemProps,
      highlightedIndex = context.highlightedIndex;
  var isSelected = index === highlightedIndex;
  return /*#__PURE__*/React.createElement(StyledComboBoxItem, _extends({
    onMouseDown: function onMouseDown(e) {
      return e.preventDefault();
    },
    "data-selected": isSelected,
    $selected: isSelected && !disabled,
    style: style
  }, getItemProps({
    item: item,
    index: index
  }), other), /*#__PURE__*/React.createElement(ItemContent, null, typeof children === 'string' ? /*#__PURE__*/React.createElement(DefaultBoxContainer, null, /*#__PURE__*/React.createElement(ComboBoxItemText, {
    truncate: true,
    color: "grey90"
  }, children)) : children));
};
var ItemContent = styled.div.withConfig({
  displayName: "ComboBoxItem__ItemContent",
  componentId: "vapor__fdt9wd-0"
})(["border-radius:", ";"], theme.radii[4]);
var StyledComboBoxItem = styled.div.withConfig({
  displayName: "ComboBoxItem__StyledComboBoxItem",
  componentId: "vapor__fdt9wd-1"
})(["cursor:pointer;padding:", " 0;&:first-of-type{padding-top:", ";}&:last-of-type{padding-bottom:", ";}", "{background-color:", ";}"], theme.spaces[2], theme.spaces[4], theme.spaces[4], ItemContent, function (p) {
  return p.$selected ? theme.colors.palette.whiteA10 : 'transparent';
});
var DefaultBoxContainer = styled.div.withConfig({
  displayName: "ComboBoxItem__DefaultBoxContainer",
  componentId: "vapor__fdt9wd-2"
})(["height:", ";padding:0 ", ";display:flex;align-items:center;"], theme.spaces[32], theme.spaces[8]);